// 快递分区

import httpClient from "@/services/http/mainServerClient";

import ShippingAreaDTO from "@/dto/setting/ShippingAreaDTO";

export interface ShippingAreaParams {
    bindingWaybillTemplate?: number;

    excludedCityCodes: string;

    excludedDistrictCodes: string;

    includedProvinceCodes: string;

    name: string;
}

// 获取当前店铺的所有快递分区列表
export function getSetting(): Promise<ShippingAreaDTO[]> {
    return httpClient.get(`/shippingArea`);
}

export function getSettingById(areaId: number): Promise<ShippingAreaDTO> {
    return httpClient.get(`/shippingArea/${areaId}`);
}

export function add(params: ShippingAreaParams): Promise<ShippingAreaDTO> {
    return httpClient.post("/shippingArea", params);
}

// 修改快递分区
export function update(id: number, params: ShippingAreaParams): Promise<ShippingAreaDTO> {
    return httpClient.post(`/shippingArea/update/${id}`, params);
}

// 绑定快递单模板
export function bindWaybillTemplate({ id, templateId }: any) {
    return httpClient.post(`/shippingArea/${id}:bindWaybillTemplate`, {
        templateId,
    });
}

// 绑定快递单模板
export function unbindWaybillTemplate(id: number) {
    return httpClient.post(`/shippingArea/${id}:unbindWaybillTemplate`);
}

/**删除快递分区设置 */
export function deleteSetting(id: number) {
    return httpClient.post(`/shippingArea/delete/${id}`);
}

interface LeanShippingArea {
    bindingWaybillTemplate: number

    id: number

    name: string
}

/**获取当前店铺的所有快递分区列表， 仅返回部分字段：id, name, bindingWaybillTemplate， 用于订单列表select */
export function shippingAreaListLean(): Promise<LeanShippingArea[]> {
    return httpClient.get("/shippingArea/list_lean")
}

export default {
    getSetting,
    getSettingById,
    add,
    update,
    bindWaybillTemplate,
    unbindWaybillTemplate,
    deleteSetting,
};
